import { createSelector } from 'reselect';
import get from 'lodash.get';

// Selectors
import { selectEntities } from 'services/entities/selectors';
import { selectWorkTypes } from 'services/workTypes/selectors';

const selectDefaultValues = (state, props) => props.defaultValues;

const selectInitialValues = createSelector(
    [selectDefaultValues, selectEntities, selectWorkTypes],
    (defaultValuesState, entitiesState, workTypesState) => {
        if (defaultValuesState) {
            const {
                personIds,
                timesheetId,
                entityId,
                workTypeId,
                units,
                rate,
                paidBreakMinutes,
                unpaidBreakMinutes,
                ...defaultValues
            } = defaultValuesState;

            let {
                workTypeCompositeKey,
                entityCompositeKey
            } = defaultValuesState;

            if (!workTypeCompositeKey && workTypeId) {
                const workTypeIsPieceRate = get(workTypesState, [
                    workTypeId,
                    'isPieceRate'
                ]);
                const workTypeEntityTypeId = get(workTypesState, [
                    workTypeId,
                    'entityTypeId'
                ]);
                workTypeCompositeKey = `${workTypeId}.${workTypeIsPieceRate}.${workTypeEntityTypeId}`;
            }

            if (!entityCompositeKey && entityId) {
                const entityEntityTypeId = get(entitiesState, [
                    entityId,
                    'entityTypeId'
                ]);
                entityCompositeKey = `${entityId}.${entityEntityTypeId}`;
            }

            return {
                ...defaultValues,
                personIds: personIds
                    ? personIds.map(personId => Number(personId))
                    : null,
                timesheetId: timesheetId ? Number(timesheetId) : null,
                workTypeCompositeKey,
                entityCompositeKey,
                units: units ? Number(units) : null,
                rate: rate ? Number(rate) : null,
                paidBreakMinutes: paidBreakMinutes
                    ? Number(paidBreakMinutes)
                    : null,
                unpaidBreakMinutes: unpaidBreakMinutes
                    ? Number(unpaidBreakMinutes)
                    : null,
                hasEditedUnpaidBreak: false,
                hasEditedPaidBreak: false
            };
        }

        return undefined;
    }
);

export { selectInitialValues };
